<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12">
        <Free />
      </v-col>
      <v-col>
        <h2>{{ $t('About.title') }}</h2>
        <p>
          {{ $t('About.description') }}
        </p>
        <h2>{{ $t('Timeline.title') }}</h2>
        <v-timeline
          class="mt-4 pt-0 py-0"
          dense
          align-top
        >
          <v-timeline-item
            v-for="(item, index) in $t('Timeline.list')"
            :key="index"
            small
            color="white"
          >
            <h3>{{ item.title }}</h3>
            {{ item.year }} · {{ item.company }}
            <br>
            {{ item.description }}
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Free from "@/components/content/Free";

  export default {
    name: 'Content',
    components: {
      Free
    },
    data: () => ({}),
  }
</script>